/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';


export interface RansomwareDeactivationSpecV3 { 
    /**
     * This need to be provided as false when the deployment is in ACTIVE state. Approval is required only when state is PENDING_DELETION_APPROVAL.
     */
    approve_deletion?: boolean;
    /**
     * When explicitly setting false, this is used to approve deactivation in DEACTIVATION_PENDING_APPROVAL state without automatically deleting CB child org API Key.
     */
    auto_api_key_deletion?: boolean;
    /**
     * When explicitly setting false, this is used to approve deactivation in DEACTIVATION_PENDING_APPROVAL state without automatically reconfigure to unregister IRR.
     */
    auto_irr_reconfigure?: boolean;
    /**
     * When explicitly setting false, this is used to approve deactivation in DEACTIVATION_PENDING_APPROVAL state without automatically de-provisioning CB PoP.
     */
    auto_purge?: boolean;
    /**
     * Org id
     */
    org_id: string;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
}
export namespace RansomwareDeactivationSpecV3 {
}


